/** Strip display formatting from advisor copy before sending to org-service AI context. */
const DOLLAR_AMOUNT_PATTERN = /\$[\d,]+(?:\.\d+)?/g;
const FP_ID_SUFFIX_PATTERN = /\b[a-f0-9]{8}\b/gi;

export const sanitizeAdvisorSummaryForAi = (summary: string): string =>
  summary
    .replace(DOLLAR_AMOUNT_PATTERN, '')
    .replace(FP_ID_SUFFIX_PATTERN, 'holdings')
    .replace(/\s+,/g, ',')
    .replace(/,\s*,/g, ',')
    .replace(/\s{2,}/g, ' ')
    .replace(/\s+·\s+·/g, ' · ')
    .trim();
